import { awarenessKeyOf, awarenessLabelOf } from './auraAwareness.js';

// Same shape as tarotBadges.js and itemBadges.js. Three fixed slots so the compact grid gives
// each an equal track, matching the role card.
//
// Priority is deliberately not here. It is an ordinal with nothing on a card to compare it
// against, it is already a sort, and the detail page states what it means.
const AWARENESS_ICONS = {
    known: 'fa fa-eye',
    'told-when-applied': 'fa fa-bell',
    hidden: 'fa fa-eye-slash',
};

// "Known to the bearer" and "Hidden from the bearer" both ellipsise inside a third of a card,
// which turned three of the four states into "…". The bearer is the subject of all three, so
// the verb alone carries the state at that width.
const AWARENESS_SHORT = {
    known: 'Knows',
    'told-when-applied': 'Told',
    hidden: 'Unaware',
};

export function badgesFor(aura) {
    if (!aura) return [];

    const awareness = awarenessKeyOf(aura);

    return [
        {
            label: aura.isCleansable ? 'Cleansable' : 'Not cleansable',
            short: aura.isCleansable ? 'Cleansable' : 'Permanent',
            meaning: 'Cleansing',
            shortLabel: 'Cleanse',
            icon: aura.isCleansable ? 'fa fa-soap' : 'fa fa-ban',
            slug: aura.isCleansable ? 'cleansable' : 'not-cleansable',
            facet: { id: 'cleansable', value: aura.isCleansable ? 'yes' : 'no' },
        },
        {
            label: awarenessLabelOf(aura),
            short: AWARENESS_SHORT[awareness],
            meaning: 'Bearer awareness',
            shortLabel: 'Bearer',
            icon: AWARENESS_ICONS[awareness],
            slug: awareness,
            facet: { id: 'known', value: awareness },
        },
        {
            label: aura.hasSilentVariant ? 'Silent variant' : 'Single form',
            short: aura.hasSilentVariant ? 'Silent' : 'Single',
            meaning: 'Forms',
            shortLabel: 'Forms',
            icon: aura.hasSilentVariant ? 'fa fa-volume-off' : 'fa fa-volume-up',
            slug: aura.hasSilentVariant ? 'silent' : 'single-form',
            facet: { id: 'silent', value: aura.hasSilentVariant ? 'yes' : 'no' },
        },
    ];
}

export default badgesFor;
